class Tab {
    constructor(targetId, params = {}) {
        this.settings = {
            ...this.defaults(),
            targetId,
            ...params,
        };
        this.targetObj = document.getElementById(this.settings.targetId);
        this.items = Array.from(this.targetObj.children).filter((el) => el.tagName === 'SECTION');
        //this.init();
    }

    defaults() {
        return {
            targetId: 'area-search-tabs',
            titleClass: 'js-tabs-title',
            contentClass: 'js-tabs-content',
        }
    }

    init() {
        this.createTitles();
    }

    createTitles() {
        this.headerObj = document.createElement('header');
        this.headerObj.classList.add('tabs-header');
        const titles = this.targetObj.querySelectorAll(`.${this.settings.titleClass}`);
        titles.forEach((title, index) => {
            const headerItem = document.createElement('button');
            headerItem.textContent = title.textContent;
            headerItem.dataset.index = index;
            headerItem.setAttribute('type', 'button');
            this.headerObj.appendChild(headerItem);

            headerItem.addEventListener('click', () => {
                this.showContent(index);
            });
        });

        this.targetObj.prepend(this.headerObj);
        this.items[0].dataset.active = '';
        this.headerObj.children[0].dataset.active = '';

    }

    showContent(index) {
        this.items.forEach((item, i) => {
            if (i === index) {
                item.dataset.active = '';
                this.headerObj.children[i].dataset.active = '';
            } else {
                delete item.dataset.active;
                delete this.headerObj.children[i].dataset.active;
            }
        });
        this.currentPage = index;
        this.targetObj.dispatchEvent(new CustomEvent('tagChange', { detail: { currentPage: index } }));
    }
    on(eventName, callback) {
        this.targetObj.addEventListener(eventName, function (e) {
            callback(e.detail);
        });
    }
}

export default Tab;
